import React, {useContext} from "react";
import {TemplateContext} from "@common/context/TemplateContext";
import ResourceNavigation from "./ResourceNavigation";
import CMSResourceNavigation from "./CMSResourceNavigation";
import ClassNavigation from "./ClassNavigation";
import LessonNavigation from "./LessonNavigation";
import {UserContext} from "@context/UserContext";
import TestNavigation from "./TestNavigation";
import TrailNavigation from "./TrailNavigation";
import NavAccessibilityWrap from "./NavAccessibilityWrap";
import {PageMarkerNavigation} from "./PageMarkerNavigation";

const ActivityNavigation = props => {
    const {activityShortcuts} = props;
    const {user, setUser, menuPosition} = useContext(UserContext);
    const {shortcutLocation} = useContext(TemplateContext);

    const menuComponents = {
        ResourceNavigation: ResourceNavigation,
        TestNavigation: TestNavigation,
        TrailNavigation: TrailNavigation,
        ClassNavigation: ClassNavigation,
        LessonNavigation: LessonNavigation
    };


    return (
        <>
            {activityShortcuts !== undefined && activityShortcuts.length > 0 &&
                <NavAccessibilityWrap aria-label="Resource Navigation" className={'ch-page-navigation ch-activity-navigation'}>
                    {user.cmsMode &&
                        <CMSResourceNavigation shortcutLocation={shortcutLocation} />
                    }
                    {!user.cmsMode &&
                        <>
                            <PageMarkerNavigation indicatorPlacement="left"/>
                            <ul className={'ch-list'}>
                                {
                                    activityShortcuts.map((shortcut, index) => {
                                        let menuComponent = shortcut.menuComponent ? shortcut.menuComponent : undefined;
                                        const MenuComponentTag = menuComponent !== undefined ? menuComponents[menuComponent] : undefined;

                                        if (MenuComponentTag === undefined) {
                                            return null;
                                        }

                                        if (shortcut.inLesson && shortcutLocation !== 'LESSON') {
                                            return null;
                                        }

                                        if (!shortcut.inLesson && shortcutLocation == 'LESSON') {
                                            return null;
                                        }

                                        return (
                                            <MenuComponentTag key={shortcut.shortcutId} shortcut={shortcut} indicatorPlacement="right"/>
                                        )
                                    })
                                }
                            </ul>
                        </>
                    }
                </NavAccessibilityWrap>
            }
        </>
    )
}

export default ActivityNavigation;